export const Constants = {
  colors: {
    main: "#46b38c",
    mainPressed: "#378a6d",
    white: "#FFFFFF",
    greyish: "#e8e8e8",
    grey: "#616161",
    black: "#000000",
    red: "#FF0000",
    green: "#00FF00",
    blue: "#00008b",
    orange: "#f08746",
  },
  // googleMapsApiKey:
  //   process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  //   "AIzaSyDC9PZz-iVvBq79XYPO1udNypFGBe-44wY",
  // olderGoogleMapsApiKey:
  //   process.env.REACT_APP_OLD_GOOGLE_MAPS_API_KEY ||
  //   "AIzaSyBZmhQsod4pJDQvuctemtOfYnaRzOMsttg",
  // apiUrl: process.env.REACT_APP_API_URL || "http://devbackend.indilma.sn/api/",
  googleMapsApiKey: "AIzaSyDC9PZz-iVvBq79XYPO1udNypFGBe-44wY",
  olderGoogleMapsApiKey: "AIzaSyBZmhQsod4pJDQvuctemtOfYnaRzOMsttg",
  apiUrl: "http://devbackend.indilma.sn/api/",
};
